import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const services = [
  { id: "family-law", title: "Family Law", image: "/images/family.jpg" },
  { id: "wills-estate", title: "Wills and Estate", image: "/images/corporate.jpg" },
  { id: "real-estate", title: "Real Estate", image: "/images/real.webp" },
  { id: "immigration-law", title: "Immigration Law", image: "/images/immigration.jpg" },
  { id: "civil-litigation", title: "Civil Litigation", image: "/images/civil.jpg" },
  { id: "personal-injury", title: "Personal Injury", image: "/images/injury.jpg" },
  { id: "employment-law", title: "Employment Law", image: "/images/employment.jpg" },
  { id: "commercial-law", title: "Commercial Law", image: "/images/Commercial.jpeg" },
];

export default function Services() {
  return (
    <div className="bg-white min-h-screen pt-8 pb-16 px-3 sm:px-8">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-14">
        Our Services
      </h2>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
        {services.map((service, i) => (
          <Link key={i} to={`/services/${service.id}`}>
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.7, type: "spring" }}
              className="relative group rounded-3xl shadow-lg overflow-hidden min-h-[300px] md:min-h-[320px] cursor-pointer"
            >
              {/* Service Image */}
              <img
                src={service.image}
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                loading="lazy"
                style={{ transition: "transform 0.4s cubic-bezier(.4,2,.6,1)" }}
              />

              {/* Title Overlay */}
              <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/70 via-black/40 to-transparent px-7 py-6 z-10">
                <div className="text-2xl md:text-3xl font-bold text-white drop-shadow">
                  {service.title}
                </div>
              </div>
            </motion.div>
          </Link>
        ))}
      </div>
    </div>
  );
}
